import { observer } from 'mobx-react';
import * as React from 'react';

import TypedTransComponent from 'shared/components/TypedTransComponent';
import { useTypedTranslation } from 'shared/entities/localization';
import { FieldModel } from 'shared/models/form';
import { Input } from 'shared/newComponents/form';
import Typography from 'shared/newComponents/Typography';
import { TypographyType } from 'shared/newEntities/components/Typography';
import { PopupPosition } from 'shared/entities/components/Popup';

import './WidgetCreateURL.modules.scss';

type Props = {
  url: FieldModel<string>;
  className?: string;
};

const WidgetCreateURL: React.FC<Props> = ({ url, className }) => {
  const { t } = useTypedTranslation('newContainers');

  return (
    <div className={className} styleName="widget-url">
      <Typography fontType={TypographyType.text}>
        <TypedTransComponent
          ns="newContainers"
          i18nKey="ChannelsModal.ChannelForm.Widget.CreateURL.description"
          components={{ br: <br /> }}
        />
      </Typography>

      <Input
        label={t('ChannelsModal.ChannelForm.url')}
        value={url.value}
        onChange={url.changeValue}
        error={url.error}
        onBlur={url.validate}
        fontSize={'s'}
        placeholder={t(
          'ChannelsModal.ChannelForm.Widget.CreateURL.placeholder'
        )}
        styleName="widget-url__input"
        reference={{
          title: (
            <TypedTransComponent
              ns="newContainers"
              i18nKey="ChannelsModal.ChannelForm.Widget.CreateURL.reference.title"
              components={{ br: <br /> }}
            />
          ),
          description: (
            <TypedTransComponent
              ns="newContainers"
              i18nKey="ChannelsModal.ChannelForm.Widget.CreateURL.reference.description"
              components={{ br: <br /> }}
            />
          ),
          position: PopupPosition.rightTop
        }}
      />
    </div>
  );
};

export default observer(WidgetCreateURL);
